var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',[_vm._v("Escolha uma opção no menu ao lado")])
}
var staticRenderFns = []

export { render, staticRenderFns }